// extracted by mini-css-extract-plugin
module.exports = {"bookmark":"ActivityContent_bookmark__35f4W"};